import { Component, OnInit } from '@angular/core';
import { LoaderService } from '@tmhcc-ng-lib/framwork/loader';
import {
  AgencyRequestContentService,
  CommonContentService
} from '@tmhcc-ng-lib/content-service';

@Component({
  selector: 'ae-farmers-thank-you',
  templateUrl: './farmers-thank-you.component.html',
  styleUrls: ['./farmers-thank-you.component.scss']
})
export class FarmersThankYouComponent implements OnInit {
  pageTitle: string;
  pageDescription: string;
  pageText: string;
  constructor(
    private loaderService: LoaderService,
    private SiteCoreData: AgencyRequestContentService,
    private commonContentService: CommonContentService
  ) {}

  ngOnInit(): void {
    this.commonContentService.setPageTitle();
    this.loaderService.show();
    this.agencyRequestSiteCoreData();
    window.scrollTo(0, 0);
  }
  agencyRequestSiteCoreData() {
    this.SiteCoreData.data$.subscribe(res => {
      if (res) {
        this.loaderService.hide();
        this.pageTitle = res.data[0].heading;
        this.pageText = res.data[0].text;
      }
    });
  }
}
